!(function () {
  "use strict";
  var t = {
      4487: function (t, e, i) {
        var n = i(6072);
        const r = new (class {
          constructor() {
            (this.items = Array.from(document.querySelectorAll(".cart-item"))),
              this.items.forEach((t) => this.manageState(t)),
              (this.selectorsToUpdate = [
                ".cart-summary__header",
                "#cart-total-price",
                "#checkout",
                ".cart-summary__free-shipping",
              ]),
              (this.mainCartSelector = ".shopify-section.cart"),
              (this.miniCart = document.getElementById("mini-cart")),
              (this.itemsContainersSelector =
                ".cart-items-container, .cart__empty, .mini-cart--empty"),
              (this.parser = new DOMParser());
          }
          manageState(t) {
            const e = t.getAttribute("data-variant-id");
            t.querySelector(
              ".cart-item-delete, .cart-item__remove"
            ).addEventListener("click", async () => {
              await this.changeCartItem({ id: e, quantity: 0 }), t.remove();
            });
            const i = t.querySelector('input[name="quantity"]');
            if (!i) return;
            const n = t.querySelector('button[name="plus"]'),
              r = t.querySelector('button[name="minus"]'),
              a = t.querySelector('input[name="quantity"]');
            let o = parseInt(i.value);
            n.addEventListener("click", () => {
              (o += 1),
                (i.value = o),
                this.changeCartItem({ id: e, quantity: o });
            }),
              r.addEventListener("click", () => {
                (o -= 1),
                  (i.value = o),
                  this.changeCartItem({ id: e, quantity: o });
              }),
              a.addEventListener("change", (t) => {
                parseInt(t.target.value) > 0
                  ? ((o = parseInt(t.target.value)),
                    this.changeCartItem({ id: e, quantity: o }))
                  : (a.value = o);
              }),
              a.addEventListener("keypress", (t) => {
                ((8 !== t.which && 0 !== t.which && t.which < 48) ||
                  t.which > 57) &&
                  t.preventDefault();
              });
          }
          async changeCartItem(t) {
            const e = {
              ...(0, n.Q2)(),
              body: JSON.stringify({
                line: +t.id,
                quantity: t.quantity,
                sections: "main-cart",
              }),
            };
            fetch(`${routes.cartChange}`, e)
              .then((t) => t.json())
              .then((t) => {
                const e = (e) => {
                  const i = this.parser.parseFromString(e, "text/html");
                  if (0 === t.item_count) {
                    const t = document.querySelector(this.mainCartSelector);
                    t &&
                      (t.innerHTML = i.querySelector(
                        this.mainCartSelector
                      ).innerHTML),
                      this.renderElements(i);
                  } else this.renderItems(i);
                };
                if (t.sections && null !== t.sections["main-cart"])
                  e(t.sections["main-cart"]);
                else {
                  const t = `${window.location.pathname}?section_id=main-cart`;
                  fetch(t)
                    .then((t) => t.text())
                    .then((t) => {
                      e(t);
                    });
                }
                const i = `${window.location.pathname}?section_id=navigation-main`;
                fetch(i)
                  .then((t) => t.text())
                  .then((e) => {
                    const i = this.parser.parseFromString(e, "text/html");
                    if (0 === t.item_count) {
                      const t = document.querySelector("#mini-cart");
                      t &&
                        ((t.innerHTML =
                          i.querySelector("#mini-cart").innerHTML),
                        t.addEventListeners(),
                        t
                          .querySelectorAll(".icon")
                          .forEach((t) => t.classList.add("loaded")));
                    }
                  });
              })
              .catch((t) => {
                console.error(t);
              });
          }
          renderElements(t) {
            this.selectorsToUpdate.forEach((e) => {
              try {
                const i = document.querySelectorAll(e),
                  n = t.querySelector(e);
                i.length &&
                  n &&
                  i.forEach((t) => {
                    n
                      .querySelectorAll(".icon")
                      .forEach((t) => t.classList.add("loaded")),
                      t.replaceWith(n.cloneNode(!0));
                  });
              } catch (t) {
                console.error(`Error updating ${e}`, t);
              }
            });
            const e = t.querySelector(".cart-count");
            document
              .querySelectorAll(
                "#cart-open-block .header__icons--cart-open .cart-count"
              )
              .forEach((t) => {
                e
                  ? (t.classList.contains("visually-hidden") &&
                      t.classList.remove("visually-hidden"),
                    (t.textContent = e.textContent))
                  : t.classList.add("visually-hidden");
              }),
              document
                .querySelector("#cart-open-block .icon")
                .classList.add("loaded");
          }
          renderItems(t) {
            this.renderElements(t);
            const e = Array.from(
                document.querySelectorAll(this.itemsContainersSelector)
              ),
              i = t.querySelector(this.itemsContainersSelector);
            e.forEach((t) => {
              t && t.replaceWith(i.cloneNode(!0));
            }),
              document.querySelectorAll(".cart-item").forEach((t) => {
                t
                  .querySelectorAll(".icon")
                  .forEach((t) => t.classList.add("loaded")),
                  this.manageState(t);
              });
          }
          updateMiniCart(t) {
            return fetch("/?section_id=main-cart")
              .then((t) => t.text())
              .then((e) => {
                this.renderItems(
                  new DOMParser().parseFromString(e, "text/html")
                ),
                  t &&
                    "mini-cart" === cartStrings.uxCart &&
                    this.miniCart &&
                    this.miniCart.open();
              })
              .catch((t) => {
                console.error("Error updating mini cart:", t);
              });
          }
        })();
        (e.Z = r),
          customElements.get("cart-note") ||
            customElements.define(
              "cart-note",
              class extends HTMLElement {
                constructor() {
                  super(),
                    this.querySelector("textarea").addEventListener(
                      "change",
                      (0, n.Ds)((t) => {
                        const e = JSON.stringify({ note: t.target.value });
                        fetch(`${routes.cartUpdate}`, {
                          ...(0, n.Q2)(),
                          body: e,
                        });
                      }, 300)
                    );
                }
              }
            );
      },
      1717: function (t, e, i) {
        i.d(e, {
          f: function () {
            return a;
          },
        });
        var n = i(6072),
          r = i(4487);
        const a = () => {
          const t = document.querySelectorAll(
              'form[data-type="add-to-cart-form"]'
            ),
            e = document.getElementById("main-cart"),
            i = document.getElementById("mini-cart"),
            a = document.querySelector("body");
          t.length &&
            t.forEach((t) =>
              t.addEventListener("submit", (o) => {
                o.preventDefault(),
                  o.stopPropagation(),
                  o.target.querySelector(
                    'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                  ) &&
                    (o.target.querySelector(
                      'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                    ).textContent = `${cartStrings.addingToCart}`);
                const s = o.target.querySelector('button[type="submit"]'),
                  c = s.querySelector("span.cart-icon"),
                  l = s.querySelector("svg.loading-icon");
                a.classList.remove("added-to-cart"),
                  s.classList.add("added"),
                  (c.style.display = "none"),
                  (l.style.display = "block");
                const d = (0, n.Q2)("javascript");
                (d.headers["X-Requested-With"] = "XMLHttpRequest"),
                  delete d.headers["Content-Type"];
                const u = new FormData(t);
                u.append("sections", "main-cart"),
                  (d.body = u),
                  fetch(`${routes.cartAdd}`, d)
                    .then((t) => t.json())
                    .then(async (t) => {
                      if (t.status) {
                        if (
                          (r.Z.updateMiniCart(!0),
                          (c.style.display = "inline-flex"),
                          (l.style.display = "none"),
                          o.target.querySelector(
                            'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                          ) &&
                            (o.target.querySelector(
                              'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                            ).textContent = `${cartStrings.addToCart}`),
                          "object" == typeof t.description)
                        )
                          return Object.entries(t.description).forEach((t) => {
                            let [e, i] = t;
                            const n = `${i.join(", ")}`;
                            o.target.querySelector(
                              ".main-product__error"
                            ).innerHTML =
                              '<span class="icon loaded">error</span><p>' +
                              n +
                              "</p>";
                          });
                        o.target.querySelector(
                          ".main-product__error"
                        ).innerHTML =
                          '<img src="https://cdn.shopify.com/s/files/1/0709/5261/6094/files/Small_Exclamation_Mark_Mascot.png?v=1753494368" alt="Error Icon" style="height:2.5em;width:auto;" /><p>' +
                          t.description +
                          "</p>";
                      } else {
                        if ("cart" === cartStrings.uxCart)
                          return void (window.location.href =
                            window.routes.cart);
                        if (
                          ((o.target.querySelector(
                            ".main-product__error"
                          ).innerHTML = ""),
                          e && e.classList.add("added"),
                          t.sections && null !== t.sections["main-cart"])
                        )
                          r.Z.renderItems(
                            new DOMParser().parseFromString(
                              t.sections["main-cart"],
                              "text/html"
                            )
                          );
                        else {
                          const t = `${window.location.pathname}?section_id=main-cart`;
                          fetch(t)
                            .then((t) => t.text())
                            .then((t) => {
                              r.Z.renderItems(
                                new DOMParser().parseFromString(t, "text/html")
                              );
                            });
                        }
                        "mini-cart" === cartStrings.uxCart && i && i.open(),
                          o.target.querySelector(
                            'button[type="submit"] >span:not(.cart-icon):not(:empty)'
                          ) &&
                            (o.target.querySelector(
                              'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                            ).textContent = `${cartStrings.addedToCart}`),
                          s.classList.remove("added"),
                          s.classList.add("successful"),
                          (c.style.display = "flex"),
                          (l.style.display = "none"),
                          a.classList.add("added-to-cart");
                      }
                    })
                    .catch((t) => {
                      console.error("Error:", t);
                    });
              })
            );
        };
      },
      6072: function (t, e, i) {
        i.d(e, {
          Ds: function () {
            return a;
          },
          Q2: function () {
            return n;
          },
          hO: function () {
            return r;
          },
          zx: function () {
            return s;
          },
        });
        const n = function () {
            return {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: `application/${
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : "json"
                }`,
              },
            };
          },
          r = function () {
            let t =
              arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            const e = window.innerWidth - document.body.offsetWidth,
              i = document.getElementById("nav-wrapper");
            t
              ? (document.body.classList.add("no-scroll"),
                (document.body.style.paddingRight = e + "px"),
                (i.style.paddingRight = e + "px"))
              : (document.body.classList.remove("no-scroll"),
                (document.body.style.paddingRight = "0px"),
                (i.style.paddingRight = "0px"));
          };
        function a(t, e) {
          const i = this;
          let n;
          return function () {
            for (var r = arguments.length, a = new Array(r), o = 0; o < r; o++)
              a[o] = arguments[o];
            clearTimeout(n),
              (n = setTimeout(function () {
                return t.apply(i, a);
              }, e));
          };
        }
        document.querySelectorAll(".local-scroll").forEach((t) => {
          t.addEventListener("click", (t) => {
            t.preventDefault(), t.stopPropagation();
            const e = t.target.getAttribute("href");
            !(function (t) {
              let e =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : 0;
              const i = document.getElementById("nav-wrapper"),
                n = document
                  .querySelector(".header")
                  .getAttribute("data-ux-position"),
                r = t.getBoundingClientRect().top;
              window.scrollTo({
                top:
                  "off" !== n
                    ? r + window.scrollY - e + parseFloat(i.style.marginTop)
                    : r + window.scrollY - e,
                behavior: "smooth",
              });
            })(document.querySelector(e));
          });
        });
        const o = {};
        function s(t) {
          document.removeEventListener("focusin", o.focusin),
            document.removeEventListener("focusout", o.focusout),
            document.removeEventListener("keydown", o.keydown),
            t && t.focus();
        }
      },
    },
    e = {};
  function i(n) {
    var r = e[n];
    if (void 0 !== r) return r.exports;
    var a = (e[n] = { exports: {} });
    return t[n](a, a.exports, i), a.exports;
  }
  (i.d = function (t, e) {
    for (var n in e)
      i.o(e, n) &&
        !i.o(t, n) &&
        Object.defineProperty(t, n, { enumerable: !0, get: e[n] });
  }),
    (i.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (function () {
      var t = i(6072),
        e = i(1717);
      document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll(".icon").forEach((t) => {
          t.classList.add("loaded");
        }),
          document.querySelectorAll('a[target="_blank"]').forEach((t) => {
            t.innerHTML =
              t.innerHTML +
              '<span class="visually-hidden"> ' +
              accessibilityNoticeNewTab +
              "</span>";
          }),
          (0, e.f)();
      }),
        void 0 !== window.BOOMR &&
          console.log(
            "Built with " +
              window.BOOMR.themeName +
              " (https://themes.shopify.com/themes/align/) version " +
              window.BOOMR.themeVersion +
              " by Company XYZ (https://companyxyz.io/)."
          ),
        void 0 === window.Shopify && (window.Shopify = {}),
        (Shopify.bind = function (t, e) {
          return function () {
            return t.apply(e, arguments);
          };
        }),
        (Shopify.setSelectorByValue = function (t, e) {
          for (var i = 0, n = t.options.length; i < n; i++) {
            var r = t.options[i];
            if (e == r.value || e == r.innerHTML)
              return (t.selectedIndex = i), i;
          }
        }),
        (Shopify.addListener = function (t, e, i) {
          t.addEventListener
            ? t.addEventListener(e, i, !1)
            : t.attachEvent("on" + e, i);
        }),
        (Shopify.postLink = function (t, e) {
          var i = (e = e || {}).method || "post",
            n = e.parameters || {},
            r = document.createElement("form");
          for (var a in (r.setAttribute("method", i),
          r.setAttribute("action", t),
          n)) {
            var o = document.createElement("input");
            o.setAttribute("type", "hidden"),
              o.setAttribute("name", a),
              o.setAttribute("value", n[a]),
              r.appendChild(o);
          }
          document.body.appendChild(r),
            r.submit(),
            document.body.removeChild(r);
        }),
        (Shopify.CountryProvinceSelector = function (t, e, i) {
          (this.countryEl = document.getElementById(t)),
            (this.provinceEl = document.getElementById(e)),
            (this.provinceContainer = document.getElementById(
              i.hideElement || e
            )),
            Shopify.addListener(
              this.countryEl,
              "change",
              Shopify.bind(this.countryHandler, this)
            ),
            this.initCountry(),
            this.initProvince();
        }),
        (Shopify.CountryProvinceSelector.prototype = {
          initCountry: function () {
            var t = this.countryEl.getAttribute("data-default");
            Shopify.setSelectorByValue(this.countryEl, t),
              this.countryHandler();
          },
          initProvince: function () {
            var t = this.provinceEl.getAttribute("data-default");
            t &&
              this.provinceEl.options.length > 0 &&
              Shopify.setSelectorByValue(this.provinceEl, t);
          },
          countryHandler: function (t) {
            var e = (r =
                this.countryEl.options[
                  this.countryEl.selectedIndex
                ]).getAttribute("data-provinces"),
              i = JSON.parse(e);
            if ((this.clearOptions(this.provinceEl), i && 0 == i.length))
              this.provinceContainer.style.display = "none";
            else {
              for (var n = 0; n < i.length; n++) {
                var r;
                ((r = document.createElement("option")).value = i[n][0]),
                  (r.innerHTML = i[n][1]),
                  this.provinceEl.appendChild(r);
              }
              this.provinceContainer.style.display = "";
            }
          },
          clearOptions: function (t) {
            for (; t.firstChild; ) t.removeChild(t.firstChild);
          },
          setOptions: function (t, e) {
            var i = 0;
            for (e.length; i < e.length; i++) {
              var n = document.createElement("option");
              (n.value = e[i]), (n.innerHTML = e[i]), t.appendChild(n);
            }
          },
        }),
        document.querySelectorAll("video").forEach((t) => {
          (t.muted = !0),
            new IntersectionObserver(
              (e) => {
                e.forEach((e) => {
                  e.isIntersecting
                    ? 1 == t.autoplay &&
                      t.paused &&
                      t.play().catch((t) => {
                        "AbortError" !== t.name &&
                          console.error("Error playing video:", t);
                      })
                    : t.pause();
                });
              },
              { threshold: 0 }
            ).observe(t);
        }),
        document.querySelectorAll("video.hover-play").forEach((t) => {
          const e = t.closest(".card");
          t.pause(),
            e
              ? (e.addEventListener("mouseenter", () => {
                  t.play().catch((t) => {
                    "AbortError" !== t.name &&
                      console.error("Error playing video:", t);
                  });
                }),
                e.addEventListener("mouseleave", () => {
                  t.pause();
                }))
              : (t.addEventListener("mouseenter", () => {
                  t.play().catch((t) => {
                    "AbortError" !== t.name &&
                      console.error("Error playing video:", t);
                  });
                }),
                t.addEventListener("mouseleave", () => {
                  t.pause();
                }));
        });
      const n = function () {
        [].slice.call(document.querySelectorAll("video")).forEach((t) => {
          const e = t.parentElement.querySelector(".figure--video__poster");
          e &&
            e.addEventListener("click", () => {
              e.classList.add("hidden"), t.play();
            });
        });
        var t = [].slice.call(
          document.querySelectorAll(".figure--video-external")
        );
        if ("IntersectionObserver" in window) {
          var e = new IntersectionObserver(function (t, e) {
            t.forEach(function (t) {
              if (t.isIntersecting)
                "vimeo" == t.target.dataset.type &&
                  fetch(
                    "http://vimeo.com/api/v2/video/" +
                      t.target.dataset.id +
                      ".json"
                  )
                    .then((t) => {
                      if (!t.ok) throw new Error(`HTTP error ${t.status}`);
                      return t.json();
                    })
                    .then((e) => {
                      t.target.querySelector(
                        ".figure--video__external-poster-image"
                      ).src = e[0].thumbnail_large;
                    }),
                  t.target.addEventListener("click", function () {
                    if (!t.target.querySelector("iframe")) {
                      let t = this.dataset.type,
                        e = document.createElement("iframe");
                      e.setAttribute("frameborder", "0"),
                        e.setAttribute("allowfullscreen", ""),
                        e.setAttribute("allow", "autoplay"),
                        "youtube" == t
                          ? (e.setAttribute("id", "youtube"),
                            e.setAttribute(
                              "src",
                              "https://www.youtube.com/embed/" +
                                this.dataset.id +
                                this.dataset.videotags +
                                "rel=0&showinfo=0&autoplay=1"
                            ))
                          : e.setAttribute(
                              "src",
                              "https://player.vimeo.com/video/" +
                                this.dataset.id +
                                this.dataset.videotags +
                                "rel=0&showinfo=0&autoplay=1"
                            ),
                        this.appendChild(e),
                        setTimeout(() => {
                          this.querySelector(
                            ".figure--video__poster"
                          ).classList.add("hidden");
                        }, 350);
                    }
                  });
              else if (t.target.querySelector("iframe")) {
                let i = t.target.dataset.type,
                  n = t.target.querySelectorAll("iframe");
                if ("youtube" == i) {
                  var e = { event: "command", func: "pauseVideo" };
                  n[0].contentWindow.postMessage(JSON.stringify(e), "*");
                } else
                  "vimeo" == i &&
                    ((e = { method: "pause", value: "true" }),
                    n[0].contentWindow.postMessage(JSON.stringify(e), "*"));
              }
            });
          });
          t.forEach(function (t) {
            e.observe(t);
          });
        }
      };
      n(),
        window.addEventListener("beforeprint", () => {
          const t = document.body.querySelectorAll("details"),
            e = document.body.querySelectorAll("img");
          for (let e = 0; e < t.length; e++)
            t[e].open
              ? (t[e].dataset.open = "1")
              : t[e].setAttribute("open", "");
          for (let t = 0; t < e.length; t++) e[t].dataset.open = "1";
        }),
        window.addEventListener("afterprint", () => {
          const t = document.body.querySelectorAll("details");
          for (let e = 0; e < t.length; e++)
            t[e].dataset.open
              ? (t[e].dataset.open = "")
              : t[e].removeAttribute("open");
        }),
        Shopify.designMode &&
          document.addEventListener("shopify:section:load", () => {
            n(),
              document.querySelectorAll(".icon").forEach((t) => {
                t.classList.add("loaded");
              });
          });
      class r extends HTMLElement {
        constructor() {
          super(),
            this.addEventListener("change", (t) => {
              const e = new CustomEvent("variant-update", {
                detail: {
                  event: t,
                  section: this.dataset.section,
                  product: this.dataset.product,
                  block: this.dataset.block,
                },
                bubbles: !0,
              });
              this.dispatchEvent(e);
            }),
            document.addEventListener("variant-update", (t) => {
              this.dataset.section === t.detail.section &&
                this.dataset.product === t.detail.product &&
                this.dataset.block === t.detail.block &&
                (t.detail.event.target.closest("variant-selects") !== this &&
                  this.syncSelection(t.detail.event.target),
                this.onVariantChange());
            }),
            (this.isCardBasedProductForm =
              null !== this.closest(".card__content"));
        }
        connectedCallback() {
          (this.mainProductUniqueIdentifier =
            "main-product-" + this.dataset.product),
            (this.uniqueIdentifier =
              this.dataset.section +
              "-" +
              this.dataset.product +
              (this.dataset.block ? "-" + this.dataset.block : ""));
        }
        onVariantChange() {
          this.updateOptions(),
            this.updateMasterId(),
            this.currentVariant
              ? (this.updateVariantStatuses(),
                this.updateImageSwatches(),
                this.updateMedia(),
                this.updateURL(),
                this.updateLinks(),
                this.renderProductInfo(),
                this.updateVariantInput(),
                this.updateAddToCart())
              : void 0 === this.currentVariant && this.setUnavailable();
        }
        syncSelection(t) {
          const { name: e, value: i } = t,
            n = this.querySelector(`[name="${e}"]`),
            r = null == n ? void 0 : n.tagName;
          n &&
            ("SELECT" === r
              ? (this.querySelector(`[name="${e}"] [value="${i}"]`).selected =
                  !0)
              : (this.querySelector(`[name="${e}"][value="${i}"]`).checked =
                  !0));
        }
        updateOptions() {
          this.options = Array.from(
            this.querySelectorAll("select, fieldset"),
            (t) => {
              return "SELECT" === t.tagName
                ? t.value
                : "FIELDSET" === t.tagName
                ? null ===
                    (e = Array.from(t.querySelectorAll("input")).find(
                      (t) => t.checked
                    )) || void 0 === e
                  ? void 0
                  : e.value
                : void 0;
              var e;
            }
          );
        }
        updateMasterId() {
          this.options.includes(void 0)
            ? (this.currentVariant = null)
            : (this.currentVariant = this.getVariantData().find(
                (t) =>
                  !t.options.map((t, e) => this.options[e] === t).includes(!1)
              ));
        }
        updateVariantStatuses() {
          const t = this.querySelector(":checked").value,
            e = this.getVariantData().filter((e) => e.options[0] === t);
          this.getProductVariantSelects().forEach((t) => {
            const i = t.querySelectorAll("select, fieldset");
            i.forEach((t, n) => {
              if (0 === n) return;
              const r = t.querySelectorAll('input[type="radio"], option'),
                a = i[n - 1].querySelector(":checked").value,
                o = e
                  .filter((t) => t.available && t[`option${n}`] === a)
                  .map((t) => t[`option${n + 1}`]);
              this.setInputAvailability(r, o);
            });
          });
        }
        setInputAvailability(t, e) {
          t.forEach((t) => {
            const i = t.getAttribute("value"),
              n = e.includes(i);
            "OPTION" === t.tagName &&
              (t.innerText = n
                ? i
                : window.productStrings.unavailable_with_option.replace(
                    "[value]",
                    i
                  ));
          });
        }
        updateImageSwatches() {
          this.querySelectorAll("fieldset:has(.image-swatch)").forEach((t) => {
            const e = t.dataset.optionPosition,
              i = t.querySelectorAll(".image-swatch");
            for (const t of i) {
              const i = [...this.options];
              i[e - 1] = t.value;
              const n = this.getVariantData().find(
                (t) =>
                  t.options[0] == i[0] &&
                  t.options[1] == i[1] &&
                  t.options[2] == i[2]
              );
              if (!n) continue;
              const r = t.labels[0],
                a = r.querySelectorAll("img.variant-image"),
                o = r.querySelector(`img[data-variant-id="${n.id}"]`),
                s = r.querySelector(".image_swatch--text_value");
              a.forEach((t) => {
                t.classList.add("hidden");
              }),
                s.classList.add("u-hide"),
                o ? o.classList.remove("hidden") : s.classList.remove("u-hide");
            }
          });
        }
        updateMedia() {
          if (!this.currentVariant) return;
          if (!this.currentVariant.featured_media) return;
          const t = document.querySelector(`#gallery-${this.uniqueIdentifier}`),
            e = t.dataset.variantStyle;
          if (this.currentVariant.featured_media) {
            const r = this.currentVariant.featured_media.id;
            if ("default" == e)
              if (t.swiper.initialized) {
                var i, n;
                const e =
                    null !== (i = t.swiper.virtual) &&
                    void 0 !== i &&
                    null !== (n = i.slides) &&
                    void 0 !== n &&
                    n.length
                      ? t.swiper.virtual.slides
                      : t.swiper.slides,
                  a = Array.from(e).findIndex((t) => t.dataset.id == r);
                -1 !== a && t.swiper.slideToLoop(a);
              } else {
                const e = t.querySelector(`[data-id="${r}"]`);
                e && t.prepend(e);
              }
            else if ("variant" == e) {
              const e = t.querySelector(`[data-id="${r}"]`);
              e &&
                (t.firstChild.classList.add("u-hide"),
                e.classList.remove("u-hide"),
                t.prepend(e));
            }
            const a = document.querySelector(
              `#sticky-gallery-${this.uniqueIdentifier}`
            );
            if (a) {
              const t = a.querySelectorAll(".sticky-add-to-cart__image"),
                e = this.currentVariant.id;
              t.forEach((t) => {
                t.dataset.variantId == e
                  ? t.classList.remove("u-hide")
                  : t.classList.add("u-hide");
              });
            }
          }
        }
        updateURL() {
          if ("false" === this.dataset.updateUrl) return;
          const t = `${this.dataset.url}?variant=${this.currentVariant.id}`;
          window.history.replaceState({}, "", t);
        }
        updateLinks() {
          if (!this.isCardBasedProductForm) return;
          const t = this.closest(".card__content").querySelector(
            ".button--view-product"
          );
          "A" === (null == t ? void 0 : t.tagName) &&
            (t.href =
              this.dataset.url.split("?")[0] +
              `?variant=${this.currentVariant.id}`);
        }
        updateVariantInput() {
          document
            .querySelectorAll(
              `#form-product-${this.uniqueIdentifier}, #form-product-installment-${this.uniqueIdentifier}`
            )
            .forEach((t) => {
              const e = t.querySelector('input[name="id"]');
              (e.value = this.currentVariant.id),
                e.dispatchEvent(new Event("change", { bubbles: !0 }));
            });
        }
        renderProductInfo() {
          var e;
          const i = document.getElementById(`price-${this.uniqueIdentifier}`);
          i &&
            (i.classList.contains("price--on-sale")
              ? i
                  .querySelectorAll(".price__sale .price-item")
                  .forEach((t) => t.classList.add("skeleton-loading"))
              : i
                  .querySelector(".price__regular")
                  .classList.add("skeleton-loading"));
          const n = document.getElementById(
            `sticky-price-${this.uniqueIdentifier}`
          );
          n &&
            (n.classList.contains("price--on-sale")
              ? n
                  .querySelectorAll(".price__sale .price-item")
                  .forEach((t) => t.classList.add("skeleton-loading"))
              : n
                  .querySelector(".price__regular")
                  .classList.add("skeleton-loading"));
          const r = document.getElementById(
            `pickup-availability-${this.uniqueIdentifier}`
          );
          null == r ||
            null === (e = r.querySelector(".skeleton-loading-wrapper")) ||
            void 0 === e ||
            e.classList.add("skeleton-loading");
          const a = document.getElementById(
            `stock-status-${this.uniqueIdentifier}`
          );
          null == a || a.classList.add("skeleton-loading");
          const o = document.getElementById(
            `pickup-availability-modal-${this.uniqueIdentifier}`
          );
          fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
            .then((t) => t.text())
            .then((e) => {
              const s = new DOMParser().parseFromString(e, "text/html"),
                c = s.getElementById(
                  `price-${this.mainProductUniqueIdentifier}`
                );
              if (a) {
                const t = s.getElementById(
                  `stock-status-${this.mainProductUniqueIdentifier}`
                );
                t
                  ? (a.classList.remove("u-invisible"),
                    (a.innerHTML = t.innerHTML),
                    (a.classList = t.classList))
                  : null == a || a.classList.add("u-invisible");
              }
              if (
                (c && i
                  ? (i.classList.remove("u-invisible"),
                    (i.innerHTML = c.innerHTML),
                    (i.classList = c.classList))
                  : null == i || i.classList.add("u-invisible"),
                n)
              ) {
                const t = s.getElementById(
                  `sticky-price-${this.mainProductUniqueIdentifier}`
                );
                t
                  ? (n.classList.remove("u-invisible"),
                    (n.innerHTML = t.innerHTML),
                    (n.classList = t.classList))
                  : null == n || n.classList.add("u-invisible");
              }
              if (r) {
                const t = s.getElementById(
                  `pickup-availability-${this.mainProductUniqueIdentifier}`
                );
                t && ((r.innerHTML = t.innerHTML), (r.classList = t.classList));
              }
              if (o) {
                const t = s.getElementById(
                  `pickup-availability-modal-${this.mainProductUniqueIdentifier}`
                );
                t && (o.innerHTML = t.innerHTML);
              }
              const l = document.querySelector(".pickup-availability"),
                d = document.getElementById("overlay"),
                u = document.getElementById("pickup-availability-open"),
                h = document.getElementById("pickup-availability-close");
              u &&
                document
                  .getElementById("pickup-availability-open")
                  .addEventListener("click", function () {
                    l.classList.add("open"),
                      d.classList.add("open"),
                      document.body.classList.add("active", "minicart"),
                      (0, t.hO)(!0);
                  }),
                h &&
                  document
                    .getElementById("pickup-availability-close")
                    .addEventListener("click", function () {
                      l.classList.remove("open"),
                        document.body.classList.remove("active", "minicart"),
                        (0, t.hO)(!1),
                        overlay.classList.remove("open", "overlay--all"),
                        (0, t.zx)(l);
                    });
            });
        }
        updateAddToCart() {
          const t = document.querySelectorAll(
            `.form-product-${this.uniqueIdentifier}`
          );
          t &&
            (this.currentVariant.available
              ? t.forEach((t) => {
                  const e = t.querySelector('[name="add"]'),
                    i = t.querySelector('[name="add"] > span:not(.cart-icon)');
                  e &&
                    (e.removeAttribute("disabled"),
                    (i.textContent = `${cartStrings.addToCart}`));
                })
              : t.forEach((t) => {
                  const e = t.querySelector('[name="add"]'),
                    i = t.querySelector('[name="add"] > span:not(.cart-icon)');
                  e &&
                    (e.setAttribute("disabled", "disabled"),
                    (i.textContent = `${cartStrings.soldOut}`));
                }));
        }
        setUnavailable() {
          const t = document.querySelectorAll(
              `.form-product-${this.uniqueIdentifier}`
            ),
            e = document.getElementById(
              `stock-status-${this.uniqueIdentifier}`
            );
          t.forEach((t) => {
            const i = t.querySelector('[name="add"]'),
              n = t.querySelector('[name="add"] > span:not(.cart-icon)');
            i &&
              ((n.textContent = `${cartStrings.unavailable}`),
              i.setAttribute("disabled", "disabled"),
              e && (e.dataset.state = "unavailable"));
          });
          const i = document.getElementById(`price-${this.uniqueIdentifier}`),
            n = document.getElementById(
              `sticky-price-${this.uniqueIdentifier}`
            );
          i && this.setPriceUnavailable(i), n && this.setPriceUnavailable(n);
        }
        setPriceUnavailable(t) {
          t.classList.remove("price--on-sale"),
            t.classList.add("price--sold-out"),
            (t.querySelector(
              ".price__regular .price-item.price-item--regular"
            ).textContent = window.productStrings.price_unavailable);
        }
        getVariantData() {
          return (
            (this.variantData =
              this.variantData ||
              JSON.parse(
                this.querySelector('[type="application/json"]').textContent
              )),
            this.variantData
          );
        }
        getProductVariantSelects() {
          return document.querySelectorAll(
            `variant-selects[data-section="${this.dataset.section}"][data-product="${this.dataset.product}"][data-block="${this.dataset.block}"]`
          );
        }
      }
      customElements.get("variant-selects") ||
        customElements.define("variant-selects", r);
      class a {
        constructor(t) {
          (this.el = t),
            (this.summary = t.querySelector("summary")),
            (this.content = t.querySelector(".content")),
            (this.animation = null),
            (this.isClosing = !1),
            (this.isExpanding = !1),
            this.summary.addEventListener("click", (t) => this.onClick(t));
        }
        onClick(t) {
          t.preventDefault(),
            (this.el.style.overflow = "hidden"),
            this.isClosing || !this.el.open
              ? this.open()
              : (this.isExpanding || this.el.open) && this.shrink();
        }
        shrink() {
          this.isClosing = !0;
          const t = `${this.el.offsetHeight}px`,
            e = `${this.summary.offsetHeight}px`;
          this.animation && this.animation.cancel(),
            (this.animation = this.el.animate(
              { height: [t, e] },
              { duration: 400, easing: "ease-out" }
            )),
            (this.animation.onfinish = () => this.onAnimationFinish(!1)),
            (this.animation.oncancel = () => (this.isClosing = !1));
        }
        open() {
          (this.el.style.height = `${this.el.offsetHeight}px`),
            (this.el.open = !0),
            window.requestAnimationFrame(() => this.expand());
        }
        expand() {
          this.isExpanding = !0;
          const t = `${this.el.offsetHeight}px`,
            e = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
          this.animation && this.animation.cancel(),
            (this.animation = this.el.animate(
              { height: [t, e] },
              { duration: 400, easing: "ease-out" }
            )),
            (this.animation.onfinish = () => this.onAnimationFinish(!0)),
            (this.animation.oncancel = () => (this.isExpanding = !1));
        }
        onAnimationFinish(t) {
          (this.el.open = t),
            (this.animation = null),
            (this.isClosing = !1),
            (this.isExpanding = !1),
            (this.el.style.height = this.el.style.overflow = "");
        }
      }
      document.querySelectorAll("details.accordion__wrapper").forEach((t) => {
        new a(t);
      });
    })();
})();